
import RecognizeWhatMatters from "../solutions/RecognizeWhatMatters";

export { Page }

function Page() {
  return <RecognizeWhatMatters />;
}
